export enum FilterOperator {
  Eq = 'eq',
  Ne = 'ne',
  Gt = 'gt',
  Gte = 'gte',
  Lt = 'lt',
  Lte = 'lte',
  REGEX = 'REGEX',
  In = 'in',
  Nin = 'nin',
  Filteraction = 'filteraction'
}

export enum OperatorDisplay {
  Equals = '=',
  NotEquals = '≠',
  GreaterThan = '>',
  GreaterThanOrEqual = '>=',
  LessThan = '<',
  LessThanOrEqual = '<=',
  Regex = 'RGX',
  Filteraction = 'filteraction'
}

/** Accepts enum members and plain strings from API/state (same runtime values as FilterOperator). */
export type Operator = FilterOperator | `${FilterOperator}`

export type Operators = {
  operator: Operator
  des: OperatorDisplay
}

export type OperatorsList = {
  [key: string]: Array<Operators>
}
